var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/createMentionPlugin.ts
import { createPluginFactory, removeNodes } from "@udecode/plate-common";

// src/handlers/mentionOnKeyDownHandler.ts
import { isHotkey as isHotkey2 } from "@udecode/plate-common";

// src/queries/findMentionInput.ts
import {
  findNode,
  getPluginType
} from "@udecode/plate-common";
var findMentionInput = (editor, options) => findNode(editor, __spreadProps(__spreadValues({}, options), {
  match: { type: getPluginType(editor, ELEMENT_MENTION_INPUT) }
}));

// src/queries/isNodeMentionInput.ts
import {
  getPluginType as getPluginType2
} from "@udecode/plate-common";
var isNodeMentionInput = (editor, node) => {
  return node.type === getPluginType2(editor, ELEMENT_MENTION_INPUT);
};

// src/queries/isSelectionInMentionInput.ts
var isSelectionInMentionInput = (editor) => findMentionInput(editor) !== void 0;

// src/transforms/removeMentionInput.ts
import {
  getNode,
  insertText,
  unwrapNodes,
  withoutNormalizing
} from "@udecode/plate-common";
var removeMentionInput = (editor, path) => withoutNormalizing(editor, () => {
  const node = getNode(editor, path);
  if (!node)
    return;
  const { trigger } = node;
  insertText(editor, trigger, {
    at: { path: [...path, 0], offset: 0 }
  });
  unwrapNodes(editor, {
    at: path
  });
});

// src/handlers/moveSelectionByOffset.ts
import {
  isHotkey,
  moveSelection
} from "@udecode/plate-common";
import { Range } from "slate";
var moveSelectionByOffset = (editor, { query = () => true } = {}) => (event) => {
  const { selection } = editor;
  if (!selection || Range.isExpanded(selection) || !query(editor)) {
    return false;
  }
  if (isHotkey("left", event)) {
    event.preventDefault();
    moveSelection(editor, { unit: "offset", reverse: true });
    return true;
  }
  if (isHotkey("right", event)) {
    event.preventDefault();
    moveSelection(editor, { unit: "offset" });
    return true;
  }
};

// src/handlers/mentionOnKeyDownHandler.ts
var mentionOnKeyDownHandler = (options) => (editor) => (event) => {
  if (isHotkey2("escape", event)) {
    const currentMentionInput = findMentionInput(editor);
    if (currentMentionInput) {
      event.preventDefault();
      removeMentionInput(editor, currentMentionInput[1]);
      return true;
    }
    return false;
  }
  return moveSelectionByOffset(editor, options)(event);
};

// src/withMention.ts
import { comboboxActions } from "@udecode/plate-combobox";
import {
  getEditorString,
  getNodeString,
  getPlugin,
  getPointBefore,
  getRange,
  setSelection
} from "@udecode/plate-common";
import { Range as Range2 } from "slate";
var withMention = (editor, {
  options: { id, trigger, triggerPreviousCharPattern, query, inputCreation }
}) => {
  const { type } = getPlugin(editor, ELEMENT_MENTION_INPUT);
  const {
    apply,
    insertBreak,
    insertText: insertText3,
    deleteBackward,
    insertFragment,
    insertTextData,
    insertNode
  } = editor;
  const stripNewLineAndTrim = (text) => {
    return text.split(/\r\n|\r|\n/).map((line) => line.trim()).join("");
  };
  editor.insertFragment = (fragment) => {
    const inMentionInput = findMentionInput(editor) !== void 0;
    if (!inMentionInput) {
      return insertFragment(fragment);
    }
    return insertText3(
      fragment.map((node) => stripNewLineAndTrim(getNodeString(node))).join("")
    );
  };
  editor.insertTextData = (data) => {
    const inMentionInput = findMentionInput(editor) !== void 0;
    if (!inMentionInput) {
      return insertTextData(data);
    }
    const text = data.getData("text/plain");
    if (!text) {
      return false;
    }
    editor.insertText(stripNewLineAndTrim(text));
    return true;
  };
  editor.deleteBackward = (unit) => {
    const currentMentionInput = findMentionInput(editor);
    if (currentMentionInput && getNodeString(currentMentionInput[0]) === "") {
      return removeMentionInput(editor, currentMentionInput[1]);
    }
    deleteBackward(unit);
  };
  editor.insertBreak = () => {
    if (isSelectionInMentionInput(editor)) {
      return;
    }
    insertBreak();
  };
  editor.insertText = (text) => {
    if (!editor.selection || text !== trigger || query && !query(editor) || isSelectionInMentionInput(editor)) {
      return insertText3(text);
    }
    const previousChar = getEditorString(
      editor,
      getRange(
        editor,
        editor.selection,
        getPointBefore(editor, editor.selection)
      )
    );
    const matchesPreviousCharPattern = triggerPreviousCharPattern == null ? void 0 : triggerPreviousCharPattern.test(previousChar);
    if (matchesPreviousCharPattern && text === trigger) {
      const data = {
        type,
        children: [{ text: "" }],
        trigger
      };
      if (inputCreation) {
        data[inputCreation.key] = inputCreation.value;
      }
      return insertNode(data);
    }
    return insertText3(text);
  };
  editor.apply = (operation) => {
    var _a, _b, _c, _d;
    apply(operation);
    if (operation.type === "insert_text" || operation.type === "remove_text") {
      const currentMentionInput = findMentionInput(editor);
      if (currentMentionInput) {
        comboboxActions.text(getNodeString(currentMentionInput[0]));
      }
    } else if (operation.type === "set_selection") {
      const previousMentionInputPath = Range2.isRange(operation.properties) ? (_a = findMentionInput(editor, { at: operation.properties })) == null ? void 0 : _a[1] : void 0;
      const currentMentionInputPath = Range2.isRange(operation.newProperties) ? (_b = findMentionInput(editor, { at: operation.newProperties })) == null ? void 0 : _b[1] : void 0;
      if (previousMentionInputPath && !currentMentionInputPath) {
        removeMentionInput(editor, previousMentionInputPath);
      }
      if (currentMentionInputPath) {
        comboboxActions.targetRange(editor.selection);
      }
    } else if (operation.type === "insert_node" && isNodeMentionInput(editor, operation.node)) {
      if (operation.node.trigger !== trigger) {
        return;
      }
      const text = (_d = (_c = operation.node.children[0]) == null ? void 0 : _c.text) != null ? _d : "";
      if (inputCreation === void 0 || operation.node[inputCreation.key] === inputCreation.value) {
        setSelection(editor, {
          anchor: { path: operation.path.concat([0]), offset: text.length },
          focus: { path: operation.path.concat([0]), offset: text.length }
        });
        comboboxActions.open({
          activeId: id,
          text,
          targetRange: editor.selection
        });
      }
    } else if (operation.type === "remove_node" && isNodeMentionInput(editor, operation.node)) {
      if (operation.node.trigger !== trigger) {
        return;
      }
      comboboxActions.reset();
    }
  };
  return editor;
};

// src/createMentionPlugin.ts
var ELEMENT_MENTION = "mention";
var ELEMENT_MENTION_INPUT = "mention_input";
var createMentionPlugin = createPluginFactory({
  key: ELEMENT_MENTION,
  isElement: true,
  isInline: true,
  isVoid: true,
  isMarkableVoid: true,
  handlers: {
    onKeyDown: mentionOnKeyDownHandler({ query: isSelectionInMentionInput }),
    onBlur: (editor) => () => {
      removeNodes(editor, {
        match: (n) => n.type === ELEMENT_MENTION_INPUT,
        at: []
      });
    }
  },
  withOverrides: withMention,
  options: {
    trigger: "@",
    triggerPreviousCharPattern: /^\s?$/,
    createMentionNode: (item) => ({ value: item.text })
  },
  plugins: [
    {
      key: ELEMENT_MENTION_INPUT,
      isElement: true,
      isInline: true
    }
  ],
  then: (editor, { key }) => ({
    options: {
      id: key
    }
  })
});

// src/getMentionOnSelectItem.ts
import {
  comboboxActions as comboboxActions2,
  comboboxSelectors
} from "@udecode/plate-combobox";
import {
  getBlockAbove,
  getPlugin as getPlugin2,
  insertNodes,
  insertText as insertText2,
  isEndPoint,
  moveSelection as moveSelection2,
  removeNodes as removeNodes2,
  select,
  withoutMergingHistory,
  withoutNormalizing as withoutNormalizing2
} from "@udecode/plate-common";
var getMentionOnSelectItem = ({
  key = ELEMENT_MENTION
} = {}) => (editor, item) => {
  var _a;
  const targetRange = comboboxSelectors.targetRange();
  if (!targetRange)
    return;
  const {
    type,
    options: { insertSpaceAfterMention, createMentionNode }
  } = getPlugin2(editor, key);
  const pathAbove = (_a = getBlockAbove(editor)) == null ? void 0 : _a[1];
  const isBlockEnd = () => editor.selection && pathAbove && isEndPoint(editor, editor.selection.anchor, pathAbove);
  withoutNormalizing2(editor, () => {
    var _a2;
    const props = createMentionNode(item, {
      search: (_a2 = comboboxSelectors.text()) != null ? _a2 : ""
    });
    select(editor, targetRange);
    withoutMergingHistory(
      editor,
      () => removeNodes2(editor, {
        match: (node) => isNodeMentionInput(editor, node)
      })
    );
    insertNodes(editor, __spreadValues({
      type,
      children: [{ text: "" }]
    }, props));
    moveSelection2(editor, { unit: "offset" });
    if (isBlockEnd() && insertSpaceAfterMention) {
      insertText2(editor, " ");
    }
  });
  return comboboxActions2.reset();
};
export {
  ELEMENT_MENTION,
  ELEMENT_MENTION_INPUT,
  createMentionPlugin,
  findMentionInput,
  getMentionOnSelectItem,
  isNodeMentionInput,
  isSelectionInMentionInput,
  mentionOnKeyDownHandler,
  moveSelectionByOffset,
  removeMentionInput,
  withMention
};
//# sourceMappingURL=index.mjs.map